import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { calcDiffDays } from '../../utils/date'
import { arranjosPrincipais } from '../../utils/arranjos'
import { cnpjCpfMask, cnpjCpfMaskHidden, parseDate } from '../../utils/masks'
import dayjs from '../../libs/dayjs'
import { moneyFormatter } from '../../utils/formatter/money'

const logo =
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="420" zoomAndPan="magnify" viewBox="0 0 428.25 304.499999" height="300" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><g/><clipPath id="275b3e3eb7"><path d="M 74.953125 75.609375 L 181.238281 75.609375 L 181.238281 191.492188 L 74.953125 191.492188 Z M 74.953125 75.609375 " clip-rule="nonzero"/></clipPath></defs><g clip-path="url(#275b3e3eb7)"><path fill="#00cc95" d="M 134.753906 85.894531 C 130.476562 83.386719 125.703125 83.386719 121.429688 85.894531 L 90.027344 103.953125 C 85.753906 106.460938 83.496094 110.472656 83.496094 115.496094 L 83.496094 151.605469 C 83.496094 156.625 85.753906 160.636719 90.027344 163.148438 L 121.429688 181.203125 C 125.703125 183.714844 130.476562 183.714844 134.753906 181.203125 L 166.152344 163.148438 C 170.429688 160.636719 172.683594 156.625 172.683594 151.605469 L 172.683594 115.496094 C 172.683594 110.472656 170.429688 106.460938 166.152344 103.953125 Z M 170.429688 96.679688 C 177.207031 100.691406 181.226562 107.460938 181.226562 115.496094 L 181.226562 151.605469 C 181.226562 159.640625 177.207031 166.410156 170.429688 170.421875 L 139.019531 188.476562 C 132.238281 192.488281 123.941406 192.488281 117.164062 188.476562 L 85.753906 170.421875 C 78.972656 166.410156 74.953125 159.640625 74.953125 151.605469 L 74.953125 115.496094 C 74.953125 107.460938 78.972656 100.691406 85.753906 96.679688 L 117.164062 78.621094 C 123.941406 74.601562 132.238281 74.601562 139.019531 78.621094 L 170.429688 96.679688 " fill-opacity="1" fill-rule="nonzero"/></g><g fill="#00cc95" fill-opacity="1"><g transform="translate(195.72861, 177.996362)"><g><path d="M 15.832031 0 L 21.644531 0 L 21.644531 -24.085938 L 34.15625 -24.085938 L 34.15625 -29.898438 L 3.320312 -29.898438 L 3.320312 -24.085938 L 15.832031 -24.085938 Z M 15.832031 0 "/></g></g></g><g fill="#00cc95" fill-opacity="1"><g transform="translate(233.204131, 177.996362)"><g><path d="M 3.320312 0 L 9.136719 0 L 9.136719 -24.085938 L 31.972656 -24.085938 L 31.972656 -29.898438 L 9.136719 -29.898438 L 3.320312 -24.085938 Z M 3.320312 0 "/></g></g></g><g fill="#00cc95" fill-opacity="1"><g transform="translate(268.499627, 177.996362)"><g><path d="M 9.136719 0 L 35.089844 0 L 35.089844 -5.8125 L 9.136719 -5.8125 L 9.136719 -12.042969 L 28.339844 -12.042969 L 28.339844 -17.855469 L 9.136719 -17.855469 L 9.136719 -24.085938 L 35.089844 -24.085938 L 35.089844 -29.898438 L 9.136719 -29.898438 L 3.320312 -24.085938 L 3.320312 -5.8125 Z M 9.136719 0 "/></g></g></g><g fill="#00cc95" fill-opacity="1"><g transform="translate(306.909432, 177.996362)"><g><path d="M 9.136719 0 L 35.089844 0 L 35.089844 -5.8125 L 9.136719 -5.8125 L 9.136719 -12.042969 L 28.339844 -12.042969 L 28.339844 -17.855469 L 9.136719 -17.855469 L 9.136719 -24.085938 L 35.089844 -24.085938 L 35.089844 -29.898438 L 9.136719 -29.898438 L 3.320312 -24.085938 L 3.320312 -5.8125 Z M 9.136719 0 "/></g></g></g><path stroke-linecap="butt" transform="matrix(-0.000000000000001447, 8.996941, -9.367054, -0.000000000000001506, 128.005398, 137.591428)" fill="none" stroke-linejoin="miter" d="M -0.000176033 0.000159242 L 10.152581 0.000159242 " stroke="#00cc95" stroke-width="1" stroke-opacity="1" stroke-miterlimit="4"/><path stroke-linecap="butt" transform="matrix(5.907146, -6.807162, 7.074666, 6.139281, 128.034409, 160.796875)" fill="none" stroke-linejoin="miter" d="M 0.0000543245 0.0000603107 L 5.317042 -0.000218765 " stroke="#00cc95" stroke-width="1" stroke-opacity="1" stroke-miterlimit="4"/><path stroke-linecap="butt" transform="matrix(5.739444, 6.925366, -7.212176, 5.97714, 108.438226, 152.409176)" fill="none" stroke-linejoin="miter" d="M 0.0000323645 0.000126439 L 3.413761 0.00000973504 " stroke="#00cc95" stroke-width="1" stroke-opacity="1" stroke-miterlimit="4"/></svg>'

const contractPdf = (
    contract: any,
    garantias: any,
    address: any,
    isExtract: boolean,
    bancos: { [key: string]: string },
    credenciadoras: { [key: string]: string }
) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs

    const reportTitle: any = []
    const totalDias = garantias.reduce((total: number, garantia: any) => {
        const diffDays = calcDiffDays(garantia.DefUR_dataFim)
        return total + diffDays
    }, 0)

    const prazoMedio = totalDias / garantias.length

    const credenciadora =
        credenciadoras[contract.credenciadora as keyof typeof credenciadoras]
    const banco = bancos[garantias[0]?.DP_compe]
    const unidadeRecebiveis = garantias.map((garantia: any) => {
        const diffDays = calcDiffDays(garantia.DefUR_dataFim)
        const expirationInDays =
            diffDays === 0
                ? '(hoje)'
                : diffDays > 0
                ? `(${diffDays} dias)`
                : `(Há ${diffDays * -1} dias)`
        const bandeira =
            arranjosPrincipais[
                garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais
            ]
        return [
            {
                text: cnpjCpfMask(contract.credenciadora),
                style: 'tableHeader',
                fontSize: 9,
                margin: [0, 10, 0, 10],
            },
            {
                text: credenciadora,
                style: 'tableHeader',
                fontSize: 9,
                margin: [0, 10, 0, 10],
            },
            {
                text: cnpjCpfMask(contract.cnpjRecebedor),
                style: 'tableHeader',
                fontSize: 9,
                margin: [0, 10, 0, 10],
            },
            {
                text: `${parseDate(
                    garantia.DefUR_dataFim,
                    true
                )} ${expirationInDays}`,
                style: 'tableHeader',
                fontSize: 9,
                margin: [0, 10, 0, 10],
            },
            // { image: '../../assets/mastercard.svg', margin: [0, 10, 0, 10]},
            {
                text: bandeira,
                style: 'tableHeader',
                fontSize: 9,
                margin: [0, 10, 0, 10],
            },
            {
                text: Number(garantia.valorAOnerar).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                }),
                style: 'tableHeader',
                fontSize: 9,
                margin: [0, 10, 0, 10],
            },
        ]
    })

    // const data = Object.entries(contract).map(([chave, value]) => {
    //     return (
    //         {

    //         }
    //     )
    // })

    const comissaoObj =
        contract.comissaoId !== null && isExtract
            ? {
                  alignment: 'left',
                  margin: [20, 0, 20, 2],
                  columns: [
                      {
                          text: [
                              {
                                  text: 'Código de referência do serviço: ',
                                  fontSize: 10,
                              },
                              {
                                  text: contract?.comissao?.referenciaExterna,
                                  style: 'text',
                                  fontSize: 10,
                              },
                          ],
                      },
                  ],
              }
            : {}

    // const line = {
    //     text: '______________________________________________________________________________________________________',
    //     margin: [0, 10, 0, 10]
    // }

    const dataContract = [
        {
            alignment: 'justify',
            columns: [
                {
                    svg: logo,
                    width: 150,
                    height: 100,
                    margin: [0, 5, 0, 0],
                    absolutePosition: { x: 12, y: -19 },
                    // width: '50%',
                    // text: [
                    //     {
                    //         text: 'Tree',
                    //         fontSize: 25,
                    //         bold: true
                    //     }
                    // ]
                },
            ],
        },
        {
            alignment: 'center',
            text: 'Comprovante do Pagamento',
            style: 'textBold',
            fontSize: 15,
            margin: [0, 10, 0, 0],
        },
        {
            alignment: 'center',
            text: dayjs(contract.createdAt).format('DD/MM/YYYY - HH:mm:ss'),
            fontSize: 11,
        },
        {
            text: '______________________________________________________________________________________________________',
            margin: [0, 10, 0, 0],
        },
        {
            text: 'Valor pago ',
            margin: [0, 10, 0, 8],
            bold: true,
            fontSize: 13,
        },
        {
            text: moneyFormatter(contract.saldoDevedor),
            margin: [0, 0, 0, 5],
        },
        {
            text: '______________________________________________________________________________________________________',
            margin: [0, 0, 0, 10],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 5],
            columns: [
                {
                    text: [
                        {
                            text: 'Situação do contrato: ',
                            style: 'textBold',
                            fontSize: 14,
                        },
                        {
                            text: !contract.visibilidade
                                ? 'Pendente de confirmação da registradora'
                                : contract.situacao,
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 5],
            columns: [
                {
                    text: [
                        {
                            text: 'Número da operação: ',
                            style: 'textBold',
                        },
                        {
                            text: contract.numeroOperacao,
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            alignment: 'left',
            columnGap: 2,
            columns: [
                {
                    text: [
                        {
                            text: 'Canal origem: ',
                            style: 'textBold',
                        },
                        {
                            text: contract.canal,
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            text: '______________________________________________________________________________________________________',
            margin: [0, 0, 0, 10],
        },
        {
            alignment: 'left',
            text: 'DADOS DO RECEBEDOR: ',
            style: 'textBold',
            fontSize: 12,
            margin: [0, 14, 0, 14],
        },
        {
            alignment: 'left',
            text: 'Para: ',
            style: 'textBold',
            fontSize: 11,
        },
        {
            alignment: 'left',
            text: contract.nomeRecebedor,
            style: 'text',
            fontSize: 12,
            margin: [0, 0, 0, 5],
        },
        {
            alignment: 'left',
            columnGap: 2,
            columns: [
                {
                    text: [
                        {
                            text: 'CPF/CNPJ: ',
                            style: 'textBold',
                        },
                        {
                            text: cnpjCpfMaskHidden(contract.cnpjRecebedor),
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            text: 'Domicílio Bancário: ',
            margin: [0, 10, 0, 10],
            bold: true,
            fontSize: 11,
        },
        {
            alignment: 'left',
            margin: [0, 0, 0, 5],
            columns: [
                {
                    width: '*',
                    text: [
                        {
                            text: 'Agência: ',
                        },
                        {
                            text: garantias[0].DP_agencia,
                            style: 'text',
                        },
                    ],
                },
                {
                    width: '*',
                    text: [
                        {
                            text: 'Número da conta: ',
                        },
                        {
                            text: garantias[0].DP_numeroConta,
                            style: 'text',
                        },
                    ],
                },
                {
                    width: '*',
                    text: [
                        {
                            text: 'Tipo de conta: ',
                            alignment: 'right',
                        },
                        {
                            text: garantias[0].DP_tipoConta,
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 5],
            columns: [
                {
                    text: [
                        {
                            text: 'Banco: ',
                        },
                        {
                            text: banco,
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            text: '______________________________________________________________________________________________________',
            margin: [0, 0, 0, 10],
        },
        {
            alignment: 'left',
            text: 'DADOS DO PAGADOR: ',
            style: 'textBold',
            fontSize: 12,
            margin: [0, 14, 0, 14],
        },
        {
            alignment: 'left',
            text: 'De: ',
            style: 'textBold',
            fontSize: 11,
        },
        {
            alignment: 'left',
            text: contract.nomePagador,
            style: 'text',
            fontSize: 12,
            margin: [0, 0, 0, 5],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 10],
            columns: [
                {
                    text: [
                        {
                            text: 'CPF/CNPJ: ',
                            style: 'textBold',
                        },
                        {
                            text: cnpjCpfMaskHidden(contract.cnpjPagador),
                            style: 'text',
                        },
                    ],
                },
            ],
        },
        {
            text: '______________________________________________________________________________________________________',
            margin: [0, 0, 0, 0],
        },
        // {
        //     alignment: 'left',
        //     margin: [0, 0, 0, 5],
        //     columns: [
        //         {
        //             text: [
        //                 {
        //                     text: 'Comissao Tree: ',
        //                     style: 'textBold',
        //                 },
        //                 {
        //                     text: Number(contract?.comissao?.saldoDevedor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
        //                     style: 'text',

        //                 },
        //             ],
        //         },

        //     ]
        // },
        // {
        //     alignment: 'left',
        //     margin: [0, 0, 0, 5],
        //     columns: [
        //         {
        //             text: [
        //                 {
        //                     text: 'Valor Total dos Créditos com Comissão: ',
        //                     style: 'textBold',
        //                 },
        //                 {
        //                     text: Number(Number(contract?.saldoDevedor) + Number(contract?.comissao?.saldoDevedor)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
        //                     style: 'text',

        //                 },
        //             ],
        //         },

        //     ]
        // },
    ]
    const details: any = [
        ...dataContract,
        {
            text: 'Agenda',
            alignment: 'center',
            margin: [0, 10, 0, 20],
            styles: 'subTitle',
            fontSize: 19,
            bold: true,
            pageBreak: 'before',
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 5],
            columns: [
                {
                    text: [
                        {
                            text: 'Prazo médio: ',
                            style: 'textBold',
                            fontSize: 11,
                        },
                        {
                            text: `${Math.round(prazoMedio) || 0} dias`,
                            style: 'text',
                            fontSize: 11,
                        },
                    ],
                },
            ],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 5],
            columns: [
                {
                    text: [
                        {
                            text: 'Quantidade de URs: ',
                            style: 'textBold',
                            fontSize: 11,
                        },
                        {
                            text: garantias.length,
                            style: 'text',
                            fontSize: 11,
                        },
                    ],
                },
            ],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 5],
            columns: [
                {
                    text: [
                        {
                            text: 'Credenciadora: ',
                            style: 'textBold',
                            fontSize: 11,
                        },
                        {
                            text: credenciadora,
                            style: 'text',
                            fontSize: 11,
                        },
                    ],
                },
            ],
        },
        {
            alignment: 'left',
            columnGap: 2,
            margin: [0, 0, 0, 14],
            columns: [
                {
                    text: [
                        {
                            text: 'Importante: ',
                            style: 'textBold',
                            fontSize: 11,
                        },
                        {
                            text: 'O(s) pagamento(s) serão efetuados pela credenciadora na data de vencimentos das URs.',
                            style: 'text',
                            fontSize: 11,
                        },
                    ],
                },
            ],
        },
        {
            table: {
                headerRows: 1,
                widths: ['auto', 'auto', 'auto', '*', 'auto', '*'],
                margin: [0, 0, 0, 12],
                body: [
                    [
                        {
                            text: 'CNPJ Credenciadora',
                            style: 'tableHeader',
                            bold: true,
                            fontSize: 10,
                            margin: [0, 0, 0, 10],
                        },
                        {
                            text: 'Credenciadora',
                            style: 'tableHeader',
                            bold: true,
                            fontSize: 10,
                            margin: [0, 0, 0, 10],
                        },
                        {
                            text: 'CNPJ Recebedor',
                            style: 'tableHeader',
                            bold: true,
                            fontSize: 10,
                            margin: [0, 0, 0, 10],
                        },
                        {
                            text: 'Data de Vencimento',
                            style: 'tableHeader',
                            bold: true,
                            fontSize: 10,
                            margin: [0, 0, 0, 10],
                        },
                        {
                            text: 'Bandeira',
                            style: 'tableHeader',
                            fontSize: 10,
                            bold: true,
                            margin: [0, 0, 0, 10],
                        },
                        {
                            text: 'Valor',
                            style: 'tableHeader',
                            fontSize: 10,
                            bold: true,
                            margin: [0, 0, 0, 10],
                        },
                    ],
                    ...unidadeRecebiveis,
                ],
            },
            // layout: 'lightHorizontalLines'
        },
    ]
    function rodape(currentPage: any, pageCount: any): any {
        return [
            {
                alignment: 'left',
                columnGap: 2,
                margin: [20, 20, 20, 2],
                columns: [
                    {
                        text: [
                            {
                                text: 'Data e hora do pagamento: ',
                                fontSize: 10,
                            },
                            {
                                text: dayjs(contract.createdAt).format(
                                    'DD/MM/YYYY - HH:mm:ss'
                                ),
                                style: 'text',
                                fontSize: 10,
                            },
                        ],
                    },
                ],
            },
            {
                alignment: 'left',
                columnGap: 2,
                margin: [20, 0, 20, 2],
                columns: [
                    {
                        text: [
                            {
                                text: 'Código de referência do pagamento: ',
                                fontSize: 10,
                            },
                            {
                                text: contract.referenciaExterna,
                                style: 'text',
                                fontSize: 10,
                            },
                        ],
                    },
                ],
            },
            comissaoObj,
            {
                alignment: 'left',
                columnGap: 0,
                margin: [20, 0, 20, 2],
                columns: [
                    {
                        text: [
                            {
                                text: 'Observação/descrição: ',
                                fontSize: 10,
                            },
                            {
                                text: contract?.observacao || 'n/a',
                                style: 'text',
                                fontSize: 10,
                            },
                        ],
                    },
                ],
            },
            {
                text: currentPage + ' / ' + pageCount,
                alignment: 'right',
                margin: [0, 10, 20, 0],
                style: 'footer',
            },
            {
                alignment: 'center',
                text: 'TREE TECNOLOGIA E CONSULTORIA LTDA',
                fontSize: 10,
            },
            {
                alignment: 'center',
                text: 'CNPJ: 45.434.171/0001-67',
                fontSize: 10,
            },
            {
                alignment: 'center',
                text: 'www.treeweb.com.br',
                fontSize: 10,
            },
        ]
    }

    const docDefinitions: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [20, 40, 20, 130],
        header: [reportTitle],
        content: [details],
        footer: rodape,
        styles: {
            header: {
                fontSize: 25,
                bold: true,
            },
            footer: {
                fontSize: 10,
            },
            title: {
                fontSize: 15,
            },
            subTitle: {
                fontSize: 20,
            },
            text: {
                fontSize: 12,
            },
            textSmall: {
                fontSize: 10,
            },
            textBold: {
                fontSize: 12,
                bold: true,
            },
            textRow: {
                fontSize: 9,
            },
        },
    }

    return pdfMake.createPdf(docDefinitions).download()
}

export default contractPdf
